import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "media" }
const _hoisted_5 = { class: "media-left" }
const _hoisted_6 = { class: "image is-48x48" }
const _hoisted_7 = {
  key: 1,
  class: "app-icon"
}
const _hoisted_8 = ["xlink:href"]
const _hoisted_9 = { class: "media-content" }
const _hoisted_10 = { class: "title is-4" }
const _hoisted_11 = { class: "subtitle is-6" }
const _hoisted_12 = { class: "modal-card-body" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

import { InstalledApp, AppConfigViewModel } from '@/features/apps/shared/models';
import CapableAppSelection from './CapableAppSelection.vue';
import CapableAppConfig from './CapableAppConfig.vue';
import { ConfigRequest } from './configRequest';
import { PropType, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CapableAppModal',
  props: {
  capableApps: {
    type: Array as PropType<InstalledApp[]>,
    required: true,
  },
  configRequest: {
    type: Function as PropType<
      (workspaceId: string, installedAppId: string, values: any, storedData: any, componentId: any) => Promise<any>
    >,
    required: true,
  },
  modalHeading: {
    type: String,
    required: true,
  },
},
  emits: ["completed", "close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const currentApp = ref<InstalledApp | null>(null);

function getTitle() {
  if (currentApp.value) {
    return currentApp.value.name;
  }
  return props.modalHeading;
}

function getSubtitle() {
  if (currentApp.value) {
    if (currentApp.value.description) {
      return currentApp.value.description;
    }
    return 'Private app';
  }
  return 'Select from your installed apps';
}

function getIcon() {
  if (!currentApp.value) {
    return { type: 'fontawesome', icon: 'cubes' };
  }
  if (currentApp.value.icon) {
    return { type: 'svg', icon: currentApp.value.icon };
  }
  return { type: 'fontawesome', icon: 'code' };
}

function close() {
  emit('close');
}

function onAppSelected(app: InstalledApp) {
  if (app.hasConfigUrl) {
    currentApp.value = app;
  } else {
    complete(app.installedAppId, {});
  }
}

function complete(installedAppId: string, config: any) {
  emit('completed', installedAppId, config);
  close();
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-background" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("figure", _hoisted_6, [
              (getIcon().type === 'fontawesome')
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    class: "apps-icon",
                    icon: getIcon().icon
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              (getIcon().type === 'svg')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                    _createElementVNode("use", {
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      "xlink:href": `#${getIcon().icon}`
                    }, null, 8, _hoisted_8)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("strong", null, _toDisplayString(getTitle()), 1)
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(getSubtitle()), 1)
          ])
        ]),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
        })
      ]),
      _createElementVNode("section", _hoisted_12, [
        (!currentApp.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(CapableAppSelection, {
                capableApps: __props.capableApps,
                onSelected: onAppSelected
              }, null, 8, ["capableApps"])
            ]))
          : _createCommentVNode("", true),
        (currentApp.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(CapableAppConfig, {
                installedApp: currentApp.value,
                configRequest: __props.configRequest,
                onConfigured: complete
              }, null, 8, ["installedApp", "configRequest"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})